import React, { useContext } from "react";
import PropTypes from "prop-types";
import { GlobalContext } from "GlobalContext";
import Link from "ui/Link";
import Reveal from "ui/Reveal";

import {
  RecentPostsBlockWrapper,
  Title,
  PostsGrid,
  PosterLink,
  Poster,
} from "./styles/RecentPostsBlockStyles";

const RecentPostsBlock = ({ publicationsData }) => {
  const { navigateTo, currentLang } = useContext(GlobalContext);
  const {
    titreRubrique,
    publications,
    labelToutesLesPublications,
    lienToutesLesPublications
  } = publicationsData;
  return (
    <React.Fragment>
      <RecentPostsBlockWrapper className="posts-block">
        <div className="fixed-container">
          <Reveal>
            <Title
              className="withline"
              dangerouslySetInnerHTML={{ __html: titreRubrique }}
            />
          </Reveal>
          <PostsGrid>
            {publications &&
              publications.map((publication, i) => {
                const report = publication.lienPublication;
                if (!report) return null;
                const cover = report.publications.global.couverturePublication;
                const category = report.publicationCategories
                  ? report.publicationCategories.nodes[0].slug
                  : "uncategorized";
                const path = "/publications/" + category + "/" + report.slug;
                return (
                  <Reveal stretch key={i} delay={i * 130}>
                    <PosterLink
                      href={(currentLang === "en" ? "/en" : "") + path}
                      onClick={(e) => {
                        if (e.metaKey || e.ctrlKey || e.shiftKey) return;
                        e.preventDefault();
                        navigateTo(path);
                      }}
                    >
                      <Poster
                        src={cover.sourceUrl}
                        alt={cover.altText || ""}
                        loading="lazy"
                      />
                    </PosterLink>
                  </Reveal>
                );
              })}
          </PostsGrid>
          <Link
            label={labelToutesLesPublications}
            onClick={() => navigateTo(lienToutesLesPublications)}
          />
        </div>
      </RecentPostsBlockWrapper>
    </React.Fragment>
  );
};

RecentPostsBlock.propTypes = {};

RecentPostsBlock.defaultProps = {};

export default RecentPostsBlock;
